import { profitsWsAxiosApi } from "src/Config/axiosApi";
import * as endpoints from "./endpoints";

export class NotificationsService {
  static endpoint = `/api${endpoints.NOTIFICATIONS}`; // profitsWsAxiosApi without /api is a WebSocket instance.

  public static markAsRead = async ({
    id,
    durationMinutes,
  }: {
    id: string;
    durationMinutes?: number;
  }): Promise<any> => {
    const { data } = await profitsWsAxiosApi.put(`${this.endpoint}/${id}/read`, {
      durationMinutes,
    });

    return data;
  };
}
